import Icon from '../components/Icon.vue'

Icon.register({
  taxi: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M462 241.6c28.6 6.4 50 31.8 50 62.4v48c0 23.6-13 44-32 55.1v40.9c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32h-256v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-40.9c-19-11.1-32-31.5-32-55.1v-48c0-30.5 21.4-56 50-62.4l22-84.8c9.6-35.2 41.6-60.8 76.8-60.8h11.2v-32c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v32h11.2c35.2 0 67.2 25.6 76.8 60.8zM96 352c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM116.5 240h278.9l-17.4-67.1c-2-7.4-9.4-12.9-14.8-12.9h-214.4c-5.5 0-12.8 5.5-15.1 13.6zM416 352c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/taxi.js
// module id = null
// module chunks = 